import { render, staticRenderFns } from "./CheckboxSub.vue?vue&type=template&id=c0c19c4c&scoped=true&"
import script from "./CheckboxSub.vue?vue&type=script&lang=js&"
export * from "./CheckboxSub.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSub.vue?vue&type=style&index=0&id=c0c19c4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c19c4c",
  null
  
)

export default component.exports